<template>
  <div class="search-form">
    <b-row>
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('form_label_detail_search_vc')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="800px"
      top="10vh"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_storeSkuStatus') || '销售状态'"
            label-width="70px"
          >
            <dict-select
              v-model="form.listStoreSkuStatus"
              url="/master/common/dict/biz"
              :body="{ dictType: 'amzStoreSkuStatus' }"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              clearable
              multiple
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_goodsName') || '产品名称'">
              <el-input
                v-model.trim="form.goodsName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_operate') || '运营人员'">
              <dict-select
                v-model="form.listOperateCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                filterable
                clearable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$l('form_label_amzSkuNo') || 'SKU'">
              <el-input
                v-model.trim="form.amzSkuNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$l('form_label_asinCode') || 'ASIN'">
              <el-input
                v-model.trim="form.asinCode"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$l('form_label_fnskuCode') || 'FNSKU'">
              <el-input
                v-model.trim="form.fnskuCode"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$l('form_label_vcPo') || 'VC PO'">
              <el-input
                v-model.trim="form.vcPo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_salesVolume7d') || '七日销售量'"
              >
                <br />
                <el-col :span="11">
                  <el-input-number
                    v-model="form.salesVolume7dStart"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    controls-position="right"
                    style="width: 100%"
                    :precision="0"
                    :min="0"
                    :step="1"
                    step-strictly
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.salesVolume7dEnd"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    controls-position="right"
                    style="width: 100%"
                    :precision="0"
                    :min="0"
                    :step="1"
                    step-strictly
                  ></el-input-number>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_avgSalesVolume7d') || '七日平均销售量'"
              >
                <br />
                <el-col :span="11">
                  <el-input-number
                    v-model="form.avgSalesVolume7dStart"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    controls-position="right"
                    style="width: 100%"
                    :precision="0"
                    :min="0"
                    :step="1"
                    step-strictly
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.avgSalesVolume7dEnd"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    controls-position="right"
                    style="width: 100%"
                    :precision="0"
                    :min="0"
                    :step="1"
                    step-strictly
                  ></el-input-number>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  listApprovalStatus: ['N', 'B'],
  listOperateCode: [],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
